import { ArrowLeft } from 'lucide-react';
import Portal from '../Portal';
import MediaCard from './MediaCard';

interface MediaItem {
  id: string;
  name: string;
  signedUrl?: string;
  url?: string;
}

interface MediaPickerProps {
  type: 'image' | 'video' | 'audio';
  open?: boolean;
  onClose: () => void;
  onSelect: (item: MediaItem) => void;
  onClear?: () => void;
  items: MediaItem[];
}

export default function MediaPicker({ type, onClose, onSelect, items }: MediaPickerProps) {
  return (
    <Portal>
      <div className="shakeScope">
        <div className="fixed inset-0 z-50 bg-overlay backdrop-blur-sm" onClick={onClose} />
        <section
          className="fixed inset-4 z-50 mx-auto max-w-[1000px] rounded-2xl border border-border/60 bg-card shadow-2xl grid grid-rows-[auto_1fr] overflow-hidden max-md:inset-2.5"
          role="dialog"
          aria-modal="true"
        >
          <header className="border-b border-border/60 bg-foreground text-card flex items-center gap-4 px-5 py-3 max-md:px-3 max-md:py-2.5">
            <button
              className="bg-transparent border-0 text-card text-[22px] cursor-pointer"
              onClick={onClose}
              aria-label="Close"
            >
              <ArrowLeft size={16} />
            </button>
            <strong>Select {type}</strong>
          </header>

          <div className="p-3 overflow-auto">
            {!items?.length ? (
              <div className="text-muted-foreground p-3">No {type}s found</div>
            ) : (
              <div className="grid gap-3">
                {items.map((it) => (
                  <MediaCard
                    key={it.id}
                    type={type}
                    url={it.signedUrl || it.url || ''}
                    name={it.name}
                    onSelect={() => onSelect(it)}
                  />
                ))}
              </div>
            )}
          </div>
        </section>
      </div>
    </Portal>
  );
}
